import { render, staticRenderFns } from "./public-podcast.vue?vue&type=template&id=476ed080&scoped=true&lang=pug&"
import script from "./public-podcast.vue?vue&type=script&lang=js&"
export * from "./public-podcast.vue?vue&type=script&lang=js&"
import style0 from "./public-podcast.vue?vue&type=style&index=0&id=476ed080&prod&lang=scss&"
import style1 from "./public-podcast.vue?vue&type=style&index=1&id=476ed080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ed080",
  null
  
)

export default component.exports